const validateName = (name: string): boolean => {
  const trimmedName = name.trim();
  const regex = /^\D+/;

  return !(trimmedName.length === 0 || !regex.test(trimmedName) || trimmedName.length < 2 || trimmedName.length > 64);
};

export const validateFirstName = (firstName: string): boolean => {
  return validateName(firstName);
};

export const validateLastName = (lastName: string): boolean => {
  return validateName(lastName);
};
